import type { UserSessionData } from '@cencosud-cencommerce/paris-login';
import { createLocalStorage } from '@cencosud-cencommerce/paris-login';
import { toast } from '@cencosud-cencommerce/paris-uikit';
import type { AxiosInstance, AxiosResponse } from 'axios';
import axios from 'axios';

import { SESSION_MANAGER_HOST } from '@/constants';
import { redirectToUrl } from '@/modules/perseo-billing/utils/window';

const userEmailLocalStorage =
  createLocalStorage<UserSessionData>('sessionData');

const createHttpClient = (): AxiosInstance => {
  const client = axios.create({
    withCredentials: true
  });

  const { email } = userEmailLocalStorage.get() || {};

  const refreshToken = async (): Promise<void> => {
    try {
      if (email) {
        const response = await axios.post(
          `${SESSION_MANAGER_HOST}/refresh-token`,
          { email },
          { withCredentials: true }
        );

        if (response.status !== 200) {
          userEmailLocalStorage.remove();
        }
      } else {
        redirectToUrl('/home');
      }
    } catch (error) {
      userEmailLocalStorage.remove();
      throw error;
    }
  };

  client.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    async (error) => {
      const originalRequest = error.config;

      const skipAuthRetry =
        originalRequest.skipAuthRetry ||
        originalRequest.metadata?.skipAuthRetry;

      if (
        (!error.response ||
          error.response.status === 401 ||
          error.response.status === 403) &&
        !originalRequest._retry &&
        !skipAuthRetry
      ) {
        originalRequest._retry = true;
        try {
          await refreshToken();
          return client(originalRequest);
        } catch (refreshError) {
          toast({
            body: 'Sesión expirada, por favor haga login de nuevo.',
            status: 'error',
            position: 'bottom-left',
            preventDuplicate: true
          });
          return Promise.reject(refreshError);
        }
      }

      return Promise.reject(error);
    }
  );

  return client;
};

export default createHttpClient();
